module.exports = __webpack_public_path__ + "static/img/icon-mall-wechat-pay.da11d382.png";